import { withMotion } from '../hoc/with-motion';
import { EpisodeDetail } from '@/modules/player/components/episode-detail';

const AnimatedPage = withMotion(EpisodeDetail);

export const roles: string[] = [];
export const path = '/player/pod/:podcastId/:episodeId';
export const element = <AnimatedPage />